import React from "react";
import styles from "./BusinessTool.module.scss";
import Image from "next/image";

function BusinessTool() {
  const businessTools = [ 
    { 
      title: "Marketing & Promotion Engine", 
      icon: "/agent-icons/target.svg", 
      color: "#2563eb", // blue
      tools: [ 
        "Dynamic discount and coupon management", 
        "Flash sales and time-limited offers", 
        "Cross-selling and upselling automation", 
        "Abandoned cart recovery campaigns", 
        "Referral and affiliate program management", 
      ], 
    }, 
    { 
      title: "Inventory & Logistics", 
      icon: "/agent-icons/cart.svg", 
      color: "#f97316", // orange
      tools: [ 
        "Multi-warehouse inventory management", 
        "Real-time stock level monitoring", 
        "Automated reorder point notifications", 
        "Shipping rate calculation and optimization", 
        "Return merchandise authorization (RMA)", 
      ], 
    }, 
    { 
      title: "Customer Support Suite", 
      icon: "/agent-icons/users.svg", 
      color: "#0d9488", // teal
      tools: [ 
        "Integrated helpdesk and ticketing system", 
        "Live chat with AI-powered responses", 
        "Knowledge base and FAQ management", 
        "Customer feedback and review system", 
        "Multi-channel support (email, phone, social)", 
      ], 
    }, 
    { 
      title: "Business Intelligence", 
      icon: "/agent-icons/brain.svg", 
      color: "#8b5cf6", // purple
      tools: [ 
        "Custom dashboard creation and sharing", 
        "Predictive analytics and forecasting", 
        "A/B testing and conversion optimization", 
        "Cohort analysis and customer lifetime value", 
        "Competitive analysis and market insights", 
      ], 
    }, 
  ];
  
  return (
    <section className={styles["business-tools-section"]}>
      <div className={styles["container"]}>
        <div className={styles["header"]}>
          <h2 className="heading">Business Management Tools</h2>
          <p className="subHeading">
            Comprehensive suite of tools to manage and grow your e-commerce
            business
          </p>
        </div>

        <div className={styles["grid"]}>
          {businessTools.map((tool, index) => (
            <div key={index} className={styles["card"]}>
              <div className={styles["card-header"]}>
                <div className={styles["icon"]}  style={{ backgroundColor: tool?.color }}> 
                  <Image
                  src={tool?.icon}
                  alt={tool?.title}
                  width={28}
                  height={28}
                  className={styles.statIcon}
                /></div>
                <h3 className={styles["card-title"]}>{tool.title}</h3>
              </div>

              <div className={styles["features"]}>
                {tool.tools.map((item, itemIndex) => (
                  <div key={itemIndex} className={styles["feature-item"]}>
                    <Image
                      src="/features-icon2.webp"
                      alt="icon"
                      width={20}
                      height={20}
                      className={styles["feature-icon"]}
                    />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BusinessTool;
